import React from 'react';
import './admin-ui-icons.css';

const base = {
  width: 18,
  height: 18,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

/** Crisp close (X) for modal headers — prefer over Bootstrap btn-close / Unicode ×. */
export function IconClose(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...base} {...props}>
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  );
}

/** Smaller remove / dismiss glyph for chips, bill tiles, table row actions. */
export function IconRemove(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...base} width={14} height={14} {...props}>
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  );
}

/** Sort column inactive indicator. */
export function IconSort(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...base} width={12} height={12} strokeWidth={2.25} {...props}>
      <path d="M8 9l4-4 4 4M8 15l4 4 4-4" />
    </svg>
  );
}

export function IconSortAsc(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...base} width={12} height={12} strokeWidth={2.25} {...props}>
      <path d="M12 19V5M5 12l7-7 7 7" />
    </svg>
  );
}

export function IconSortDesc(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...base} width={12} height={12} strokeWidth={2.25} {...props}>
      <path d="M12 5v14M19 12l-7 7-7-7" />
    </svg>
  );
}

/**
 * Explicit modal close control — never rely on outside-click to dismiss.
 */
export function ModalCloseButton({ onClick, disabled = false, className = '' }) {
  return (
    <button
      type="button"
      className={`admin-modal-close${className ? ` ${className}` : ''}`}
      aria-label="Close"
      disabled={disabled}
      onClick={onClick}
    >
      <IconClose />
    </button>
  );
}
